/* @flow */
import React from 'react';

import ChatLearnMore from 'chat/components/ChatLearnMore.jsx';
import ChatStore from 'chat/stores/ChatStore';
import CurrentUser from 'auth/CurrentUser';
import { promiseGroupOrRootChats } from 'chat/utils/ChatPromises';
import GroupStore from 'groups/stores/GroupStore';
import ToastActions from 'actions/ToastActions';
import { EVERYONE } from 'utils/roleHelpers';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

class ChatDefaultView extends React.Component {
  // This code controls which chat thread is focused upon entering the /messages or /inbox routes
  static onEnter(
    nextState: RouterState,
    replaceWith: (location: LocationDescriptor) => void,
    callback: Function,
  ) {
    const { groupCode } = nextState.params;
    const group = GroupStore.getGroupForCode(groupCode);
    const user = CurrentUser.getUser();
    if (!group || !user) {
      callback();
      return;
    }

    promiseGroupOrRootChats(groupCode).then(() => {
      const { query } = nextState.location;

      // If the user can send announcements to this group, redirect to the appropriate announcements thread
      const postableRoles = group.getPostableRoles();
      if (postableRoles.length) {
        const target = postableRoles.includes(EVERYONE) ? EVERYONE : postableRoles[0];
        replaceWith({
          pathname: `/classes/${groupCode}/messages/announcements/${target}`,
          query,
        });
      } else {
        // Otherwise, focus the first chat, if any
        const chats = ChatStore.getChats(group);
        const firstChat = chats.find(chat => !chat.isNew());
        if (firstChat) {
          replaceWith({ pathname: `/classes/${groupCode}/messages/${firstChat.id}`, query });
        }
      }

      callback();
    }).catch(err => {
      ToastActions.showErrorToast(
        'Messages could not be loaded. Please wait and try again later.'
      );
      console.warn(err);
      callback();
    });
  }

  render() {
    return <ChatLearnMore groupCode={this.props.params.groupCode} />;
  }
}

export default ChatDefaultView;



// WEBPACK FOOTER //
// ./src/chat/components/ChatDefaultView.jsx